import { render, staticRenderFns } from "./DispatchItems.vue?vue&type=template&id=ae5c4218&scoped=true&"
import script from "./DispatchItems.vue?vue&type=script&lang=js&"
export * from "./DispatchItems.vue?vue&type=script&lang=js&"
import style0 from "./DispatchItems.vue?vue&type=style&index=0&id=ae5c4218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5c4218",
  null
  
)

export default component.exports